import { defineMessages } from 'react-intl';

export const estimationTabMessageDefinitions = defineMessages({
  projectLabel: {
    id: 'estimationDetail.tab.project.label',
    defaultMessage: 'Project',
  },
  metadataLabel: {
    id: 'estimationDetail.tab.metadata.label',
    defaultMessage: 'Master Data',
  },
  estimationLabel: {
    id: 'estimationDetail.tab.estimation.label',
    defaultMessage: 'Estimation',
  },
  estimationAssumptionsLabel: {
    id: 'estimationDetail.tab.estimationAssumptions.label',
    defaultMessage: 'Assumptions',
  },
  resourceLabel: {
    id: 'estimationDetail.tab.resource.label',
    defaultMessage: 'Resource',
  },
  resourceCostLabel: {
    id: 'estimationDetail.tab.resourceCost.label',
    defaultMessage: 'Resource Cost',
  },
  directCostLabel: {
    id: 'estimationDetail.tab.directCost.label',
    defaultMessage: 'Direct Cost',
  },
  costSummaryLabel: {
    id: 'estimationDetail.tab.costSummary.label',
    defaultMessage: 'Summary of Costs',
  },
  managementReportLabel: {
    id: 'estimationDetail.tab.managementReport.label',
    defaultMessage: 'Management Report',
  },
  reviewLabel: {
    id: 'estimationDetail.tab.review.label',
    defaultMessage: 'Review',
  },
  reviewCommentsSummaryTitle: {
    id: 'estimationDetail.reviewCommentsSummary.title',
    defaultMessage: 'Review comments summary',
  },
  reviewCommentsSummaryNotAvailable: {
    id: 'estimationDetail.reviewCommentsSummary.notAvailable',
    defaultMessage:
      'No summary available yet. Complete a review cycle (Send Back or Approve) to see the summary here.',
  },
  sendBackButton: {
    id: 'estimationDetail.sendBackButton',
    defaultMessage: 'Send Back',
  },
  approveButton: {
    id: 'estimationDetail.approveButton',
    defaultMessage: 'Approve',
  },
  currentVersion: {
    id: 'estimationDetail.currentVersion',
    defaultMessage: 'version: {versionNumber}',
  },
  activeVersion: {
    id: 'estimationDetail.activeVersion',
    defaultMessage: 'Active version: {versionNumber}',
  },
  workingVersion: {
    id: 'estimationDetail.workingVersion',
    defaultMessage: 'Working version: {versionNumber}',
  },
  createNewVersion: {
    id: 'estimationDetail.createNewVersion',
    defaultMessage: 'Create New Version',
  },
  renameVersion: {
    id: 'estimationDetail.renameVersion',
    defaultMessage: 'Rename Version',
  },
  viewAllVersions: {
    id: 'estimationDetail.viewAllVersions',
    defaultMessage: 'View all versions',
  },
  versionName: {
    id: 'estimationDetail.versionName',
    defaultMessage: 'Version Name',
  },
  versionCreated: {
    id: 'estimationDetail.versionCreated',
    defaultMessage: 'Version {versionName} has been successfully created.',
  },
  versionRenamed: {
    id: 'estimationDetail.versionRenamed',
    defaultMessage: 'Estimation version has been successfully renamed.',
  },
  methodologyChangeConfirmationModalTitle: {
    id: 'estimationDetail.methodologyChangeConfirmationModal.title',
    defaultMessage: 'Changing methodology',
  },
  methodologyChangeConfirmationModalWarningMessage: {
    id: 'estimationDetail.methodologyChangeConfirmationModal.warningMessage',
    defaultMessage:
      'This action will change methodology on all sub-phases. As a consequence, its parameters will be regenerated and the related entered estimates will get lost. The operation cannot be reverted.',
  },
  modalSavedMessage: {
    id: 'estimationDetail.detail.saved',
    defaultMessage: 'Estimation item "{mainEstimationItemName}" has been saved.',
  },
  resetResourceNamesToDefaults: {
    id: 'estimationDetail.tab.resource.resetNamesToDefaults',
    defaultMessage: 'Reset all to defaults',
  },
});
